import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning-circle",
  "use": "icon-warning-circle-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warning-circle\">\n  <circle cx=\"10\" cy=\"10\" r=\"9\" fill=\"#FEF0C7\" stroke=\"#F79009\" stroke-width=\"1.5\" />\n  <path d=\"M10 5.75V10.5\" stroke=\"#F79009\" stroke-width=\"1.6\" stroke-linecap=\"round\" />\n  <circle cx=\"10\" cy=\"13.9\" r=\"1.05\" fill=\"#F79009\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol